<template>
  <v-container fluid>
    <v-flex xs12>
      <v-card>
      <v-card-title>
            <span class="title">Work Jobs {{pagination? "("+pagination.totalItems+")": ""}}
            </span>
            <v-spacer></v-spacer>
            <v-btn class="blue-grey" fab small dark @click.native.stop="rightDrawer = !rightDrawer">
              <v-icon>search</v-icon>
            </v-btn>
            <v-btn class="brown lighten-1" fab small dark @click.native="reloadData()">
              <v-icon>refresh</v-icon>
            </v-btn>
            <v-btn class="teal darken-2" fab small dark @click.native="print()">
              <v-icon>print</v-icon>
            </v-btn>
            <v-btn class="deep-orange darken-3" fab small dark @click.native="add">
              <v-icon>add</v-icon>
            </v-btn>
          </v-card-title>
        <Table v-if="loading===false" :headers="headers" :items="items"  :pagination="pagination" @edit="edit"></Table>
      </v-card>
    </v-flex>
    <search-panel :rightDrawer="rightDrawer" @cancelSearch="cancelSearch" @searchData="searchOrders">
        <v-layout row>
          <v-flex xs11 offset-xs1>
            <v-text-field name="id" label="Work Job" light v-model="searchVm.equals.jobid"></v-text-field>
            <v-text-field name="custphone" label="Customer Phone" light v-model="searchVm.equals.custphone"></v-text-field>
            <v-text-field name="serialnumber" label="Serial Number" light v-model="searchVm.equals.deviceid"></v-text-field>
            <v-select name="status" :items="statuss" label="Status" light v-model="searchVm.equals.status"></v-select>
            <v-select name="techid" :items="techs" item-text="techname" item-value="techid" label="Technician" light v-model="searchVm.equals.techid"></v-select>
          </v-flex>
        </v-layout>
      </search-panel>

      <v-snackbar v-if="loading===false" :right="true" :timeout="timeout" :color="mode" v-model="snackbar" >
      {{ notice }}
      <v-btn dark flat @click.native="closeSnackbar">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>
/* globals Store */
import Table from "@/components/Table.vue";
import SearchPanel from "@/components/SearchPanel.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import { mapState } from "vuex";
import { debounce } from "lodash";
import api from "@/utils/backend-api";


export default {
  components: {
    Table,
    SearchPanel,
    ConfirmDialog
  },
  data () {
    return {
      statuss: ['Open', 'In Process', 'Closed', 'Rejected'],
      dialog: false,
      dialogTitle: "Order Delete Dialog",
      dialogText: "Do you want to delete this order?",
      rightDrawer: false,
      right: true,
      search: '',
      techs: [],
      headers: [
        {
          text: 'ID',
          left: true,
          value: 'id'
        },
        { text: 'Make', value: 'make' },
        { text: 'Model', value: 'model' },
        { text: 'Serial', value: 'deviceid' },
        { text: 'Technician', value: 'techid' },
        { text: 'Customer', value: 'custid' },
        { text: 'Description', value: 'description' },
        { text: 'Status', value: 'status' },
        { text: 'Created', value: 'createdon' },
        { text: 'Updated', value: 'lastupdated' }
      ],
      searchVm: {
        contains: {
          jobid: '',
          reference: ''
        },
        equals: {
          jobid: '',
          custphone: '',
          deviceid: '',
          status: '',
          techid: '',
        },

      },
      orderId: "",
      query: "",
      snackbarStatus: false,
      timeout: 2000,
      color: "",
      quickSearchFilter: "",
    }
  },
  methods: {
  getTechs () {
    api.getData("getTechs.php").then(
      res => {
         this.techs = res.data;
      },
      err => {
        console.log(err);
      }
    );
  },
    print () {
      window.print()
    },
    edit (item) {
      this.$router.push({ name: 'OrderDetails', params: { id: item.id } })
    },
    add () {
      this.$router.push('NewOrder')
    },
    searchOrders () {
      this.rightDrawer = !this.rightDrawer;
      this.appUtil.buildSearchFilters(this.searchVm);
      this.query = this.appUtil.buildJsonServerQuery(this.searchVm);
      Store.dispatch("orders/searchOrders", this.query, this.pagination);
    },
    reloadData () {
      this.query = "";
      Store.dispatch("orders/getAllOrders");
    },
    cancelSearch () {
      this.rightDrawer = false;
    },
    closeSnackbar () {
      Store.commit("orders/setSnackbar", { snackbar: false });
      Store.commit("orders/setNotice", { notice: "" });
    },
  },
  computed: {
    ...mapState("orders", {
      items: "items",
      pagination: "pagination",
      loading: "loading",
      mode: "mode",
      snackbar: "snackbar",
      notice: "notice"
    }),
  },
  created () {
    Store.dispatch("orders/getAllOrders");
    this.getTechs();
  },
  mounted () {
    this.$nextTick(() => {
      // console.log(this.headers);
    })
  }
}
</script>



// WEBPACK FOOTER //
// OrderList.vue?31932877